import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

import i18next from 'i18next'

import styles from './styles/questionnaire.scss'
import illustration from './../assets/images/wopi-puzzle.png'

export default class WopiStart extends React.Component {
  render() {
    const { language, onStart, uuid } = this.props

    return (
      <Grid className={styles.introductionText}>
        <Row>
          <Col md={12}>
            <h1>{i18next.t('instructions', { lng: language, ns: 'questionnaire' })}</h1>

            <Row>
              <Col md={8} style={{ textAlign: 'left' }}>
                <h2>{i18next.t('think_about_work', { lng: language, ns: 'questionnaire' })}</h2>
                <p>
                  {i18next.t('think_about_work_description', {
                    lng: language,
                    ns: 'questionnaire'
                  })}
                </p>

                <h2>{i18next.t('no_right_or_wrong', { lng: language, ns: 'questionnaire' })}</h2>
                <p>
                  {i18next.t('no_right_or_wrong_description', {
                    lng: language,
                    ns: 'questionnaire'
                  })}
                </p>

                <h2>{i18next.t('duration', { lng: language, ns: 'questionnaire' })}</h2>
                <p>{i18next.t('duration_description', { lng: language, ns: 'questionnaire' })}</p>
              </Col>

              <Col md={4}>
                <img src={illustration} className={styles.alternativeIllustration} />
              </Col>
            </Row>

            <button id="next-button" className={styles.button} onClick={() => onStart(uuid)}>
              {i18next.t('start_questionnaire', { lng: language, ns: 'questionnaire' })}
            </button>
          </Col>
        </Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WopiStart.js